import { gql, useQuery } from '@apollo/client';

export const GET_SALARY_TYPE_BY_ID = gql`
  query getSalaryTypesById($id: String!) {
    getSalaryTypesById(id: $id) {
      _id
      name
      companyId
      createdBy
      salaryTypeNumber
      clientNumbers
    }
  }
`;

export const useGetSalaryTypesById = (id?: string) => {
  const { data, loading } = useQuery(GET_SALARY_TYPE_BY_ID, {
    variables: { id },
    skip: !id,
  });

  const salaryType = data?.getSalaryTypesById || {};

  return { salaryType, loading };
};
